/**
 * @template T
 *
 * @typedef {Object} Response<T>
 * @property {T} data
 */

/**
 * @typedef {Object} Pagination
 * @property {string} path
 * @property {string} first_page_url
 * @property {string} last_page_url
 * @property {string | null} prev_page_url
 * @property {string | null} next_page_url
 * @property {number} from
 * @property {number} to
 * @property {number} total
 * @property {number} per_page
 * @property {number} current_page
 * @property {number} last_page
 * @property {Array} links
 */

/**
 * @template T
 * @typedef {Response<T> & Pagination} PaginatedResponse<T>
 */

/**
 * Extract the pagination data from a paginated response
 *
 * @param {PaginatedResponse<any>} paginated
 * @returns {Pagination}
 */
export function extractPagination(paginated) {
  // I know there is probably a more concise way to
  // do this, but at least this way I have full control
  // of the properties set.

  /** @type Pagination */
  let paginationData = {
    path: paginated.data,
    first_page_url: paginated.first_page_url,
    last_page_url: paginated.last_page_url,
    prev_page_url: paginated.prev_page_url,
    next_page_url: paginated.next_page_url,
    from: paginated.from,
    to: paginated.to,
    total: paginated.total,
    per_page: paginated.per_page,
    current_page: paginated.current_page,
    last_page: paginated.last_page,
    links: paginated.links
  };

  return paginationData;
}
